import service from '@/services/facturacion/factura'

const getDefaultState = () => ({
  mensajeReceptor: [],
  cuentaContableIVAPorCobrar: null,
  files: [],
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_MENSAJE_RECEPTOR: (state, obj) => {
    state.mensajeReceptor = obj
    state.saved = true
  },
  UPDATE_STATE_MENSAJE_RECEPTOR: (state, obj) => {
    state.mensajeReceptor = state.mensajeReceptor.map(e => ({
      ...e,
      consecutivo: obj.consecutivo,
      returnState: obj.claveFE === e.claveFE ? obj.returnState : e.returnState
    }))
    state.saved = true
  },
  CLEAN_STATE_BEFORE_SEND: (state, value) => {
    state.mensajeReceptor = state.mensajeReceptor.map(e => ({
      ...e,
      returnState: value === e.claveFE ? null : e.returnState
    }))
    state.saved = true
  },
  CLEAN_MENSAJE_RECEPTOR: state => {
    state.mensajeReceptor = []
    state.files = []
    state.saved = true
  },
  SAVE_CHANGES: (state, obj) => {
    state.files.push(obj)
    state.saved = false
  },
  REMOVE_FILE: (state, obj) => {
    state.files = state.files.filter(e => e.name !== obj.name)
    state.saved = false
  },

  REMOVE: (state, obj) => {
    state.mensajeReceptor = state.mensajeReceptor.filter(e => e.claveFE !== obj)
  },
  DELETE_ITEM: (state, obj) => {
    state.mensajeReceptor = state.mensajeReceptor.map(e => {
      return {
        ...e,
        detalleServicio: {
          lineaDetalle: e.detalleServicio.lineaDetalle.filter(r => r.detalle !== obj.detalle)
        }
      }
    })
  },
  SET_CUENTA_CONTABLE_IVA_POR_COBRAR: (state, obj) => {
    state.cuentaContableIVAPorCobrar = obj
  }
}

export const actions = {
  create({ commit, dispatch, rootGetters, state }, { item, force = false, inventario, creaClave = true, cuentaContablePago = null, accounting = false }) {
    const arrayMR = item.map(e => {
      // elimina campos innecesarios: addReady.
      e.detalleServicio.lineaDetalle.forEach(r => {
        delete r.addReady

        // conta
        if (r.cuentaContablePorPagar) {
          r.cuentaContablePorPagar = { _id: r.cuentaContablePorPagar._id }
        }

        r.item = {
          _id: r.item._id
        }

        r.conversion = Number(r.conversion)
        r.cantidadConv = Number(r.cantidadConv)
      })

      if (e.returnState !== 'ok') {
        delete e.returnState
        commit('CLEAN_STATE_BEFORE_SEND', e.claveFE)

        // agrega el id de la caja
        const cajaSesion = rootGetters['facturacion/facturaStore/getCajaSesion']

        if (cajaSesion?._id) {
          e.cajaSesion = {
            _id: cajaSesion._id,
            caja: cajaSesion.caja
          }
        }

        const { cuentaContableIVAPorCobrar } = state

        if (cuentaContableIVAPorCobrar) {
          e.cuentaContableIVAPorCobrar = cuentaContableIVAPorCobrar
        } else {
          delete e.cuentaContableIVAPorCobrar
        }

        console.log('Factura de Proveedor: ', JSON.stringify(e, null, 2))
        console.log('creaClave :>> ', creaClave)
        console.log('inventario :>> ', inventario)
        console.log('accounting :>> ', accounting)
        console.log('cuentaContablePago', cuentaContablePago)

        return service.createMensajeReceptor(e, force, inventario, creaClave, cuentaContablePago, accounting).then(result => {
          commit('UPDATE_STATE_MENSAJE_RECEPTOR', result)

          if (result?.returnState) {
            dispatch('facturacion/facturaStore/updateDocumentosCreditoMR', {}, { root: true })
          }

          console.log('result | mr', result)

          return { ...result, ...e }
        })
      }
      return { returnState: 'ok' } // no cambia el estado "ok"
    })

    return Promise.all(arrayMR).then(e => {
      const cajaSesion = rootGetters['facturacion/facturaStore/getCajaSesion']
      console.log('cajaSesion mr', cajaSesion)
      const result = e.reduce((a, it) => {
        // eslint-disable-next-line no-param-reassign
        if (it.returnState !== 'ok') a = false
        return a
      }, 'true')

      e.forEach(r => {
        if (r.returnState === 'ok' && cajaSesion._id) {
          //busca medio de pago
          const medioSelected = rootGetters['facturacion/types/medioPago/get'](r.medioPago[0].id)

          console.log('Compra medioPago :>> ', medioSelected)

          const medio = medioSelected ? medioSelected.annotation?.split(' ')[0].toUpperCase() : 'ND'
          console.log('Registra el mov en caja', medio)

          dispatch(
            'cajas/movimientoStore/create',
            {
              sesion: { _id: cajaSesion._id },
              tipo: 'COMPRA',
              montoIngreso: 0,
              montoEgreso: r.resumenFactura.totalComprobante,
              medioPago: medio,
              detalle: `Factura Compra #${r.consecutivo}`
            },
            { root: true }
          )
        }
      })

      if (result) return result
      throw new Error('Algún documento no fue procesado.')
    })
  },

  // read: ({ commit }, id) => service.readById(id).then(result => commit('SET_MENSAJE_RECEPTOR', result)),

  saveChanges: ({ commit }, item) => commit('SAVE_CHANGES', item)
}
